let viewlink =
    '<a id="viewContractbuttonHover" data-PhysicianId="#PhysicianId#" data-ProviderName="#ProviderName#" class="viewContractbuttonHover icon-action-button-normal nowrap is_mr_l_auto" style="z-index:5;" >View' +
        '<i class="viewRightArrow far fa-chevron-circle-right"></i>' +
    '</a>';

let viewHRPlink = '<a id="viewNetworkContractbuttonHover" data-PhysicianId="#PhysicianId#" data-ProviderName="#ProviderName#" class="clsProviderNetwork icon-action-button-normal"  style = "z-index:5;cursor: pointer;" >View</a>';

let providerQuickSearchFiltertype = {
    searchAll: 0,
    searchAny: 1,
    checkBoxId: "searchtype"
};

let filterTypeTemplate = {
    expand: "<div class='hgt_20'><div id='searchtypediv'> <span class='is_flex width100P'><input type = 'checkbox' id = 'searchtype' /><span class='Bold'>Expanded Search</span>&nbsp;Looks for any one of the words</span></div></div>"
};

function toggleViewIcon(current) {
    let searchContainer = $(current).closest('.acontainer');
    $('#TextSsProviderName', searchContainer).css('z-index', '');
    $('.viewRightArrow', searchContainer).removeClass('fas fa-chevron-circle-down').addClass('far fa-chevron-circle-right');
    $('#contractGridDiv', searchContainer).hide();
}

function renderContractDetails(currentObj) {
    let lobBenId = '';

    $("#contractGridCaption", currentObj.closest('.acontainer')).text("Contract Details : " + currentObj.data('providername'));

    if (window.top.$(".InAuthPage").is(":visible")) {
        lobBenId = getSelectedlobBenid();
    } else if (window.top.$(".InComplaintPage").is(":visible")) {
        let PI = AgPatient_ComplaintInfo("", "");
        let ComplaintDivId = $.trim(PI.ComplaintDivId + " #Accordion_Group_2 #ComplaintInit_2_1");
        lobBenId = getSelectedLobBenId(ComplaintDivId);
    } else {
        lobBenId = $("#Grid_AuthPatientEligibility .memberEligibility.active").data('lobbenid');
    }

    getContractDetails(currentObj.data('physicianid'), lobBenId, currentObj.closest('.acontainer'));
}

function getContractDetails(physicianId, lobBenId, currentObj) {
    $("#contractGridDivContainer", currentObj).kendoGrid({
        dataSource: {
            type: "aspnetmvc-ajax",
            transport: {
                read: {
                    url: baseApiURL + "/UMAuthProvider/GetProvidersSmartSearchContracts?ProviderId=" + physicianId + "&LobBenId=" + lobBenId,
                    type: "GET",
                    dataType: "json"
                }
            },
            pageSize: 10,
            serverPaging: true,
            serverSorting: true,
            schema: {
                data: "Data", total: "Total", errors: "Errors",
                model:
                {
                    fields: getProvidersSmartSearchContractModel()
                }
            }
        },
        height: 170,
        sortable: false,
        scrollable: true,
        autoBind: true,
        noRecords: true,
        pageable: { refresh: false, pageSizes: false, buttonCount: 5 },
        columns: getProvidersSmartSearchContractColumns(),
        dataBound: providersSmartSearchContractDataBound
    });
}

function providersSmartSearchContractDataBound() {
    kendo.resize($("#contractGridDivContainer"));
}

function getProvidersSmartSearchContractColumns() {
    return [
        { field: "UniqueDataRootPath", title: "Network Contact", template: "<div style='white-space:normal;'>#= (UniqueDataRootPath == null) ? 'N/A' : UniqueDataRootPath #</div>", width: 170, sortable: false },
        { field: "ValidityFrom", title: "Start Date", template: "#= (ValidityFrom == null) ? 'N/A' : kendo.toString(ValidityFrom, 'MM/dd/yyyy') #", width: 80, sortable: false },
        { field: "ValidityTo", title: "End Date", template: "#= (ValidityTo == null) ? 'N/A' : kendo.toString(ValidityTo, 'MM/dd/yyyy') #", width: 80, sortable: false },
        { field: "ProviderCapacity", title: "Status", template: "#= (ProviderCapacity == null) ? 'N/A' : ProviderCapacity #", width: 70, sortable: false },
        { field: "NetworkName", title: "Network Name", template: "#= (NetworkName == null) ? 'N/A' : NetworkName #", width: 150, sortable: false },
        { field: "ProviderEnrollment", title: "Provider Contract Type", template: "#= (ProviderEnrollment == null) ? 'N/A' : ProviderEnrollment #", width: 100, sortable: false }
    ];
}

function getProvidersSmartSearchContractModel() {
    return {
        UniqueDataRootPath: { type: "string" },
        ValidityFrom: { type: "date", "defaultValue": null },
        ValidityTo: { type: "date", "defaultValue": null },
        ProviderCapacity: { type: "string", "defaultValue": null },
        NetworkName: { type: "string", "defaultValue": null },
        NetworkNameId: { type: "number" },
        ProviderId: { type: "number" },
        ProvLobBenId: { type: "number" },
        ProviderEnrollment: { type: "string", "defaultValue": null }
    };
}
function showContractDetails(currentobj) {
    var currentaDropDiv = currentobj.parents('.acontainer');
    var $menu = $('#contractGridDiv', currentaDropDiv);
    $menu.hide();
    $('#providerMainGrid', currentaDropDiv).css('z-index', '10');
    $('#TextSsProviderName', currentaDropDiv).css('z-index', '8');
    var pos = currentobj.parents(".adropdown").offset();
    var parent = currentobj.parent().parent();
    $menu.show().css('top', (parent.offset().top - pos.top) + "px");
    $('.ProviderSearch-Container', currentaDropDiv).css('left', providerSearchLeft);
}

function providerSearchLeft() {
    if (window.top.$(".InAuthPage").is(":visible")) {
        return '19%';
    }
    return window.top.$(".InComplaintPage").is(":visible") ? '7%' : '11%';
}

var ProvHoverCloseDelay = 0;
function bindMouseevents() {
    $(document).on("mouseover", ".viewContractbuttonHover", function () {
        renderContractDetails($(this));
        showContractDetails($(this));
        $('.viewRightArrow', $(this)).removeClass('far fa-chevron-circle-right').addClass('fas fa-chevron-circle-down');
    });
    $(document).on("focusout mouseleave", ".viewContractbuttonHover", function () {
        clearTimeout(ProvHoverCloseDelay);
        ProvHoverCloseDelay = setTimeout(decideHideContractDiv, 300, this);
    });
    $(document).on("focusout mouseleave", "#contractGridDiv", function () {
        toggleViewIcon(this);
    });
    $(document).off('change', '#ddlProvVal, .ddlProvVal').on('change', '#ddlProvVal, .ddlProvVal', function () {
        hideProviderQuickSearchFilterCheckbox(this);
    });
}
function payloadforContractedNetworks(physicianid) {
    var patientId = 0;
    var lobBenId = 0;
    var memBenfPlanId = 0;
    var authNo = 0;
    var complaintId = 0;
    if ((window.top.$(".InAuthPage").is(":visible")) && (ToValue(benefitCheckNavID, "") === "")) {
        var authInfo = UmPatient_AuthInfo("", "");
        var authTabId = authInfo.AuthTabId;
        lobBenId = $("#HdnLobBenId", authTabId).val();
        memBenfPlanId = $("#HdnMemBenPlanId", authTabId).val();
        patientId = authInfo.PatientId;
        authNo = authInfo.AuthNo;
    }
    else if (window.top.$(".InComplaintPage").is(":visible")) {
        var complaintInfo = AgData.complaintInfo();
        var complaintTabId=complaintInfo.complaintTabId;
        lobBenId = $("#HdnLobBenId", complaintTabId).val();
        memBenfPlanId = $("#HdnMemBenPlanId", complaintTabId).val();
        patientId = complaintInfo.patientId;
        complaintId = complaintInfo.complaintNo;
    }
    else if ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) {
        patientId = $("#hdnPHPatientId").val();
        memBenfPlanId = $("#Grid_AuthPatientEligibility .memberEligibility.active", "#AuthInit_2_1").attr("value");
        lobBenId = $("#Grid_AuthPatientEligibility .memberEligibility.active", "#AuthInit_2_1").data('lobbenid');
    }
    else {
        patientId = ToValue($('#hdnPatientId').val(), null) !== null ? $('#hdnPatientId').val() : UmPatient_AuthInfo("", "").PatientId;
        lobBenId = $('#hdnBenefitLobId').val();
        memBenfPlanId = $('#hdnBenefitMemPlan').val();
    }
    return {
        PatientId: patientId,
        LobBenId: lobBenId,
        MemBenfPlanId: memBenfPlanId,
        AuthNo: authNo,
        ComplaintId: complaintId,
        PhysicianId: physicianid
    };
}
function showProviderNetworkTierInfo(networkObj) {
    $("#divProviderNetworkFormView").load(baseURL + "/Provider/ProviderNetworkView?physicianId=" + networkObj.PhysicianId + "&memBenfPlanId=" + networkObj.MemBenfPlanId, function () {
        if ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) {
            $("#divProviderNetworkFormView #divProviderNetworkDetails").css("z-index", "10013");
        }
        $("#divProviderNetworkFormView").show();
    });
}
function decideHideContractDiv(currentobj) {
    var closeContractGrid = true;
    currentobj.closest('.acontainer').querySelectorAll(":hover").forEach(function (e) {
        var eid = e.id.split('_')[0];
        if (eid === 'contractGridDiv' || eid === 'viewContractbuttonHover') {
            closeContractGrid = false;
        }
    });
    if (closeContractGrid) {
        toggleViewIcon(currentobj);
    }
}
function hideProviderQuickSearchFilterCheckbox(currentobj) {
    var selectedVal = $('option:selected', currentobj).val();
    var checkboxDivObj = $('#searchtypediv', currentobj.closest(".ProviderDiv"));
    var show = selectedVal == 'Provider Name' || selectedVal == 'Provider Code';
    checkboxDivObj[show ? "show" : "hide"]();
    if (!show) {
        $('#' + providerQuickSearchFiltertype.checkBoxId, checkboxDivObj).prop('checked', false);
    }
}
function networkViewGridcolumnsforProviderQuickSearch() {
    return {
        Columns: [
            { Width: "0", ItemKey: "PhysicianId" },
            { Width: "140", Title: "Provider Name", ItemKey: "ProviderFullNameActual", ItemNull: "N/A" },
            { Width: "100", Title: "Provider Type", ItemKey: "ProviderType", ItemNull: "N/A" },
            { Width: "100", Title: "Provider Code", ItemKey: "ProviderId", },
            { Width: "100", Title: customNameForNPI || "Provider NPI", ItemKey: "IndexValue", ItemNull: "N/A" },
            { Width: "100", Title: "Tax ID", ItemKey: "TaxId", ItemNull: "N/A" },
            { Width: "200", Title: "Address", ItemKey: "ProviderAddress", ItemNull: "N/A" },
            { Width: "70", Title: "Address Type", ItemKey: "AddressTypeName", ItemNull: "N/A" },
            { Width: "120", Title: "Matched Network", ItemKey: "NetworkName", ItemNull: "N/A" },
            { Width: "120", Title: "Network Tier", ItemKey: "NetworkTier", ItemNull: "N/A" },
            { Width: "120", Title: "All Contracted Networks", ItemKey: "", IsViewlink: viewHRPlink }
        ],
        Width: "1130px",
        Url: baseApiURL + '/UMAuthProvider/GetProvidersSmartSearchV3'
    };
}
function showProviderNetworks(physicianid) {
    var networkObj = payloadforContractedNetworks(physicianid);
    showProviderNetworkTierInfo(networkObj);
}

